export enum ActionType {
  REACT_LOAD = 'REACT_LOAD',
  LOGIN = 'LOGIN',
  AUTHENTICATE = 'AUTHENTICATE',
  URL_IFRAME = 'URL_IFRAME',

  // Auto Load Creation
  DISPLAY = 'DISPLAY',
  CLOSE = 'CLOSE',
  SAVE = 'SAVE',
  SET_PICKUP = 'SET_PICKUP',

  // Migration
  ACTIVATE_TAB = 'ACTIVATE_TAB',
  CHANGE_COMMODITY = 'CHANGE_COMMODITY',
  CHANGE_REACT_TERMINAL = 'CHANGE_REACT_TERMINAL',
  CHANGE_FLEX_TERMINAL = 'CHANGE_FLEX_TERMINAL'
}

export enum MessageType {
  DRIVER_SCHEDULE = 'DRIVER_SCHEDULE',
  AUTO_LOAD_CREATION = 'AUTO_LOAD_CREATION',
  API_SETTINGS = 'API_SETTINGS',
  SETUP = 'SETUP',
  CODE = 'CODE',
  LOAD = 'LOAD',
  DISPATCH = 'DISPATCH',
  DISPATCH_MESSAGE = 'DISPATCH_MESSAGE',
  REVIEW = 'REVIEW',
  REVIEW_COMPLIANCE = 'REVIEW_COMPLIANCE',
  FUEL_PURCHASE = 'FUEL_PURCHASE',
  DVIR = 'DVIR',
  DRIVER_ADDED_TANK = 'DRIVER_ADDED_TANK',
  VEHICLE_MAINTENANCE = 'VEHICLE_MAINTENANCE',
  RTU = 'RTU',
  STATION_LOG = 'STATION_LOG',
  REVIEW_REPORT = 'REVIEW_REPORT'
}

export enum UrlSourceType {
  DRIVER_SCHEDULE = 'driverSchedule',
  AUTO_LOAD_CREATION = 'autoLoadCreation',
  SETUP = 'setup',
  CODE = 'code',
  LOAD = 'load',
  DISPATCH = 'dispatch',
  REVIEW = 'REVIEW',
  REVIEW_COMPLIANCE = 'reviewCompliance',
  REVIEW_FUEL_PURCHASE = '/fuelPurchase',
  REVIEW_VEHICLE_MAINTENANCE = '/vehicleMaintenance',
  DVIR = '/dvir',
  DRIVER_ADDED_TANK = '/driverAddedTank',
  RTU = '/rtu',
  STATION_LOG = '/stationLog',
  REVIEW_REPORT = '/reviewReport'
}
